export const Enums = {
  Submit: "Submit",
  Yes_NO: "Yes_NO",
  Active: "active",
  dishd2hunifiedbck: "https://dishd2hunifiedbck.watcho.com/api",
  unifiedbck: "https://unifiedbck.watcho.com/api"

};
